export default "__VITE_ASSET__CNgwyuMV__"